// Helpers de categorías. La lista ahora vive en la tabla `categorias`
// de Supabase y se accede vía CategoriasContext / useCategorias().

export const obtenerCategoria = (categorias, nombre) =>
  categorias.find((c) => c.nombre === nombre);

export const iconoCategoria = (categorias, nombre) =>
  obtenerCategoria(categorias, nombre)?.icono || '📦';

// Devuelve la URL de la foto marcada como principal (con fallback a la foto 1).
export const obtenerFotoPrincipal = (producto) => {
  const idx = producto.foto_principal;
  if (idx >= 1 && idx <= 6 && producto[`foto_${idx}_url`]) return producto[`foto_${idx}_url`];
  return producto.foto_1_url;
};

// Todas las fotos cargadas del producto (la principal primero), sin repetir.
export const obtenerFotos = (producto) => {
  const todas = [1, 2, 3, 4, 5, 6].map((n) => producto[`foto_${n}_url`]).filter(Boolean);
  const principal = obtenerFotoPrincipal(producto);
  const ordenadas = principal ? [principal, ...todas.filter((u) => u !== principal)] : todas;
  return [...new Set(ordenadas.filter(Boolean))];
};
